/* Based on https://github.com/iamstarkov/jss-increase-specificity
 * Original license: MIT © Vladimir Starkov
 */
/**
 * use :not(#\20), :not(.\20) and :not(\20) instead of generating unlikely
 * appearing ids…
 * — twitter.com/subzey/status/829050478721896448
 * Rationale: \20 is a css escape for U+0020 Space, and neither classname,
 * nor id, nor tagname can contain a space
 * — twitter.com/subzey/status/829051085885153280
 */
const selector = ':not(#\\20)';
const defaultOptions = { repeat: 3 };
export default function increaseSpecificity(userOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), userOptions);
    const prefix = Array(options.repeat + 1).join(selector);
    function onProcessRule(rule, sheet) {
        const { parent } = rule.options;
        if (sheet.options.increaseSpecificity !== true
            || rule.type !== 'style'
            || (parent === null || parent === void 0 ? void 0 : parent.type) === 'keyframes') {
            return;
        }
        rule.selectorText = `${prefix}${rule.selectorText}`;
    }
    return { onProcessRule };
}
